"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var assignUid_1 = require("./assignUid");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return assignUid_1.default; } });
//# sourceMappingURL=index.js.map